import { useQuery } from "@tanstack/react-query";
import { getAllClasses } from "../../api/apiClasses";
import i18next from "i18next";

export function useGetClasses(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({
        queryKey: ["classes", page, perPage, filters, i18next.language],
        queryFn: () => getAllClasses(page, perPage, filters),
        retry: false,
    });
    const classes = data?.data?.items || [];
    const meta = data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 };
    return { isLoading, error, classes, meta };
}
